import Tooltip from '@app/ui/sports-components/Tooltip';
import React from 'react';

type TextTrackingStatusToggleCellProps = {
    ttfId: number;
    active: boolean;
    onStatusToggled: (ttfId: number, shouldActivate: boolean) => void;
};

const TextTrackingStatusToggleCell = ({
    ttfId,
    active,
    onStatusToggled,
}: TextTrackingStatusToggleCellProps) => {
    return (
        <div className="gds-form-group__toggleswitch">
            <Tooltip text={active ? 'ACTIVE' : 'INACTIVE'} position="left">
                <label className="gds-form-group__toggleswitch-label">
                    <input
                        className="gds-form-group__toggleswitch-input"
                        data-test="status-toggle"
                        name="active"
                        type="checkbox"
                        checked={active}
                        onChange={() => onStatusToggled(ttfId, !active)}
                    />
                    <span className="gds-form-group__toggleswitch-indicator -color-bg-white" />
                </label>
            </Tooltip>
        </div>
    );
};

export default TextTrackingStatusToggleCell;
